(ns common.transaction-process.validation
  (:require
   #?(:cljs [common.number-utils :as nu])
   [common.time :as time])
  #?(:clj
     (:import
      (java.time Instant ZoneOffset))))

(def day-ms 86400000)

(defn- epoch-ms->utc-day
  [epoch-ms]
  #?(:cljs (let [date (js/Date. epoch-ms)]
             (js/Date.UTC (.getUTCFullYear date)
                          (.getUTCMonth date)
                          (.getUTCDate date)))
     :clj  (-> (Instant/ofEpochMilli epoch-ms)
               (.atZone ZoneOffset/UTC)
               (.toLocalDate))))

(defn- weekend?
  [day]
  #?(:cljs (let [weekday (.getUTCDay (js/Date. day))]
             (or (= 0 weekday)
                 (= 6 weekday)))
     :clj  (let [day-of-week (.getDayOfWeek day)]
             (or (= java.time.DayOfWeek/SATURDAY day-of-week)
                 (= java.time.DayOfWeek/SUNDAY day-of-week)))))

(defn- next-day
  [day]
  #?(:cljs (+ day day-ms)
     :clj  (.plusDays day 1)))

(defn- add-business-days
  "Add n Mon-Fri business days to an epoch-ms UTC date. Bank holidays ignored."
  [start-ms n]
  (loop [day  (epoch-ms->utc-day start-ms)
         left n]
    (if (zero? left)
      day
      (let [candidate (next-day day)]
        (recur candidate
               (if (weekend? candidate)
                 left
                 (dec left)))))))

(defn- before-day?
  [day min-day]
  #?(:cljs (< day min-day)
     :clj  (.isBefore day min-day)))

(defn- comparable-number
  [value]
  #?(:clj
     (when (number? value)
       value)
     :cljs
     (cond
       (number? value)
       value

       (some? value)
       (try
         (let [numeric-value (nu/bigdec->float value)]
           (when (number? numeric-value)
             numeric-value))
         (catch :default _
           nil))

       :else
       nil)))

(defn validate-transition-field-value
  "Returns an error descriptor when `value` violates a transition validation rule."
  [{:keys [value rule field-vals now-ms]}]
  (or
   (when-let [n (:min-business-days-from-today rule)]
     (when value
       (let [value-day (epoch-ms->utc-day value)
             min-day   (add-business-days now-ms n)]
         (when (before-day? value-day min-day)
           {:rule :min-business-days-from-today
            :n    n}))))
   (when-let [comparison-field (:less-than-or-equal-to-field rule)]
     (let [numeric-value      (comparable-number value)
           comparison-value  (-> field-vals
                                 (get comparison-field)
                                 comparable-number)]
       (when (and (some? numeric-value)
                  (some? comparison-value)
                  (> numeric-value comparison-value))
         {:rule             :less-than-or-equal-to-field
          :comparison-field comparison-field})))))

(defn validate-transition-field-values
  "Validate transition field values. Returns field-kw -> error descriptor."
  [{:keys [field-validations field-vals now-ms]
    :or   {now-ms (time/now-millis)}}]
  (->> field-validations
       (keep (fn [[field-kw rule]]
               (when-let [err (validate-transition-field-value
                               {:value  (get field-vals field-kw)
                                :rule   rule
                                :field-vals field-vals
                                :now-ms now-ms})]
                 [field-kw err])))
       (into {})))
